var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRhombus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.001 255.953C448.001 250.359 446.064 244.765 442.19 240.264L242.245 8.25C237.434 2.75 230.717 0 224 0S210.567 2.75 205.756 8.25L5.811 240.264C1.937 244.765 0 250.359 0 255.953S1.937 267.141 5.811 271.641L205.756 503.654C210.567 509.219 217.284 512 224 512S237.434 509.219 242.245 503.654L442.19 271.641C446.064 267.141 448.001 261.547 448.001 255.953ZM224 451.299L55.657 255.953L224 60.605L392.344 255.953L224 451.299Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhombus);
export default __webpack_public_path__ + "static/media/rhombus.70bc4bed5363c11502ebeb56977e865e.svg";
export { ForwardRef as ReactComponent };